
class Config {
  //  apiUrl= "https://rats.azurewebsites.net/web/api";
  //  apiUrl = "https://ratsdev.azurewebsites.net/api";
      apiUrl = "https://rats-api-dev.rencata.com/api";
  //  apiUrl= "https://localhost:44359/api";
};
export default Config;